(function () {
  const BREAKPOINT = 1081;
  let nav = null;
  let lastScrollY = 0;
  let isNavVisible = true;
  let hasBeenSticky = false;

  const SCROLL_THRESHOLD = 1;

  function addStyles() {
    if (document.getElementById('collection-nav-scroll-styles')) return;
    const style = document.createElement('style');
    style.id = 'collection-nav-scroll-styles';
    style.textContent = [
      '@media (max-width: 1080px) {',
      '  .collection__nav {',
      '    top: unset !important;',
      '  }',
      '  .collection__nav--mobile-active {',
      '    position: sticky;',
      '    top: calc(var(--header-height) - var(--border-width)) !important;',
      '  }',
      '  .collection__nav--mobile-hidden {',
      '    position: unset;',
      '  }',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  function hideNav() {
    if (isNavVisible) {
      nav.classList.remove('collection__nav--mobile-active');
      nav.classList.add('collection__nav--mobile-hidden');
      isNavVisible = false;
    }
  }

  function showNav() {
    if (!isNavVisible) {
      nav.classList.remove('collection__nav--mobile-hidden');
      nav.classList.add('collection__nav--mobile-active');
      isNavVisible = true;
    }
  }

  function getHeaderHeight() {
    return (
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) ||
      60
    );
  }

  function handleScroll() {
    const currentScrollY = window.scrollY;
    const delta = currentScrollY - lastScrollY;

    // Desktop - always visible
    if (window.innerWidth >= BREAKPOINT) {
      nav.classList.remove('collection__nav--mobile-hidden', 'collection__nav--mobile-active');
      isNavVisible = true;
      hasBeenSticky = false;
      lastScrollY = currentScrollY;
      return;
    }

    // Get nav's current position relative to viewport
    const navRect = nav.getBoundingClientRect();
    const headerHeight = getHeaderHeight();

    // Nav's top position relative to viewport
    const navTopFromViewport = navRect.top;

    // If nav is still in its natural position (below the header), keep it visible
    if (navTopFromViewport > headerHeight && !hasBeenSticky) {
      // Only remove classes if they exist to prevent flicker
      if (
        nav.classList.contains('collection__nav--mobile-hidden') ||
        nav.classList.contains('collection__nav--mobile-active')
      ) {
        nav.classList.remove('collection__nav--mobile-hidden', 'collection__nav--mobile-active');
      }
      isNavVisible = true;
      lastScrollY = currentScrollY;
      return;
    }

    // Nav has reached or passed the sticky point (at header height)
    if (navTopFromViewport <= headerHeight) {
      hasBeenSticky = true;
    }

    // Reset when very close to the top
    if (currentScrollY < 50) {
      if (
        nav.classList.contains('collection__nav--mobile-hidden') ||
        nav.classList.contains('collection__nav--mobile-active')
      ) {
        nav.classList.remove('collection__nav--mobile-hidden', 'collection__nav--mobile-active');
      }
      isNavVisible = true;
      hasBeenSticky = false;
      lastScrollY = currentScrollY;
      return;
    }

    // Only react to significant scroll movements
    if (Math.abs(delta) < SCROLL_THRESHOLD) {
      return;
    }

    // Now apply hide/show logic only after nav is sticky
    if (hasBeenSticky) {
      // Scrolling down - hide
      if (delta > 0) {
        hideNav();
      }
      // Scrolling up - show with sticky positioning
      else if (delta < 0) {
        showNav();
      }
    }

    lastScrollY = currentScrollY;
  }

  function init() {
    nav = document.querySelector('.collection__nav');
    if (!nav) {
      if (document.readyState !== 'complete') {
        setTimeout(init, 100);
      }
      return;
    }

    addStyles();

    lastScrollY = window.scrollY;
    isNavVisible = true;

    // Check if we're already in sticky range on page load
    const navRect = nav.getBoundingClientRect();
    const headerHeight = getHeaderHeight();
    hasBeenSticky = navRect.top <= headerHeight;

    let ticking = false;
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          requestAnimationFrame(function () {
            handleScroll();
            ticking = false;
          });
          ticking = true;
        }
      },
      { passive: true }
    );

    window.addEventListener('resize', function () {
      if (window.innerWidth >= BREAKPOINT) {
        nav.classList.remove('collection__nav--mobile-hidden', 'collection__nav--mobile-active');
        isNavVisible = true;
        hasBeenSticky = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
